<script>
  import { session, gameId, me, update } from "../store"
  import Shell from "./Shell.svelte"
  import Count from "./Count.svelte"
  import play from "../lib/play"
  import RoundStatus from "./RoundStatus.svelte"
  import punct from "../lib/punct"

  export let sentence = ""
  export let blanks = []
  let submission = []
  let submissions = []
  let parts = []
  let lastSentence = false
  let submitted = false
  let allowSubmit

  $: {
    if (!allowSubmit && $session.allowSubmit) {
      setTimeout(() => {
        window.document.querySelector("input").focus()
        play("beep1")
      }, 100)
      allowSubmit = true
    }
  }
  $: {
    if ($session.submissions[$session.onSentence]) {
      submissions = Object.values(
        $session.submissions[$session.onSentence]
      ).sort((a, b) => a.stamp.seconds - b.stamp.seconds)
    }
    if (sentence && sentence !== lastSentence) {
      submission = []
      let matches = sentence.match(punct)
      parts = sentence
        .replace(new RegExp(`[${matches[0].split("").join("\\")}]$`), "")
        .split(" ")
        .map(content => {
          if (content[0] === "%") {
            submission.push("")
            return {
              content: blanks[+content.replace("%blank-", "")],
              inx: submission.length - 1,
              type: "input"
            }
          }
          return {
            type: "word",
            content
          }
        })
      parts.push({ type: "word", content: matches[0] })
      lastSentence = sentence
    }
  }

  function handleSubmit() {
    console.log(submissions.filter(({ submission: existing }) => true))
    if (submission.filter(val => val.length).length === submission.length) {
      play("ding")
      submitted = true
      if (
        (!submissions ||
          submissions.filter(
            ({ submission: existing }) =>
              JSON.stringify(existing) === JSON.stringify(submission)
          ).length === 0) &&
        submissions.length < $session.maxPerRound + 10
      ) {
        update(`submissions.${$session.onSentence}.%u`, {
          submission,
          stamp: new Date()
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "../vars";
  input {
    margin: 0 0.3rem;
  }
  .sentence {
    font-size: 1.25rem;
    background: l($gray, 60%);
    padding: 2rem;
    margin-bottom: 1rem;
    display: flex;
    flex-wrap: wrap;
    line-height: 170%;
    input {
      font-size: 1.2rem;
      padding: 0.4rem 0.5rem 0.5rem;
      position: relative;
      top: -1px;
      text-align: center;
      border: 2px solid d($gray, 10%);
      margin-bottom: 2px;
      &.disabled {
        background: $white !important;
        color: d($gray, 70%);
        border-style: dotted;
      }
    }
  }
  .filled {
    background: l($red, 90%);
    border: 1px dashed l($red, 70%);
    padding: 0.3rem 0.6rem;
    margin: 0 0.3rem 0 0.1rem;
  }
  button {
    background: $red;
    border: 0;
    padding: 0.6rem 2rem;
    display: block;
    cursor: pointer;
    color: $white;
    &.disabled {
      background: $gray;
      color: d($gray, 20%);
    }
  }
  .submitted {
    background: $gray;
    color: $green;
  }
</style>

<div>
  <h2>Complete the following sentence:</h2>
  <Shell>
    <form on:submit|preventDefault={handleSubmit}>
      <div class="sentence">
        {#each parts as word}
          {#if word.type === 'input'}
            <input
              type="text"
              bind:value={submission[word.inx]}
              disabled={!$session.allowSubmit}
              class:disabled={!$session.allowSubmit}
              style={`width: ${2 + word.content.length * 0.68}rem`}
              placeholder={word.content} />
          {:else}
            <span>{word.content}&nbsp;</span>
          {/if}
        {/each}
      </div>
      <div>
        <button
          type="submit"
          class:submitted
          class:disabled={!$session.allowSubmit}
          disabled={!$session.allowSubmit}>
          {$session.allowSubmit ? (submitted ? 'Submitted!' : 'Submit It!') : 'Wait to Submit'}
        </button>
      </div>
    </form>
  </Shell>
  <RoundStatus>
    <div>
      {submissions.length <= $session.maxPerRound ? submissions.length : $session.maxPerRound}/{$session.maxPerRound}
      <label>entries</label>
    </div>
    <!-- <Count /> -->
  </RoundStatus>
</div>
